module.exports = __webpack_public_path__ + "img/06.05692b2c.png";